import { makeBookingManagerApi } from 'services/BookingManagerApi/BookingManagerApi';
import {
  EInvoiceUploadStatus,
  IInvoiceUploadsQueryParams,
  IInvoiceUploadsResponse,
  TInvoiceUploadTab,
} from 'containers/InvoiceUploads/types';

const statusesForTab = (tab: TInvoiceUploadTab): EInvoiceUploadStatus[] =>
  tab === 'pending'
    ? [EInvoiceUploadStatus.PENDING]
    : [EInvoiceUploadStatus.PROCESSING, EInvoiceUploadStatus.REJECTED, EInvoiceUploadStatus.APPROVED];

export const fetchInvoiceUploads = async (
  params: IInvoiceUploadsQueryParams
): Promise<IInvoiceUploadsResponse> => {
  const api = makeBookingManagerApi();
  const response = await api.searchSupplierInvoiceImports({
    filter: { statuses: statusesForTab(params.tab) },
    pagination: { offset: params.offset, limit: params.limit },
  });
  return response.data;
};

export const parseAmountToCents = (amount: string | null | undefined): number | null => {
  if (amount == null || amount === '') return null;
  const n = Number.parseFloat(amount);
  return Number.isFinite(n) ? Math.round(n * 100) : null;
};

export const parseConfidencePercent = (confidence: string | null | undefined): number | null => {
  if (confidence == null || confidence === '') return null;
  const n = Number.parseFloat(confidence);
  return Number.isFinite(n) ? Math.round(n * 100) : null;
};
